<template>
    <div class="col-md-6 mt-2 ">
        <div class="border-bottom">
            <slot name="headline"></slot>
        </div>

        <ul v-if="filterTrainingsList.length !== 0"
            class="list-group list-group-flush">
            <li v-for="item in filterTrainingsList"
                class="list-group-item d-flex justify-content-between align-items-center">
                <div>
                    <p class="m-0">
                        <strong>Training:</strong> {{ item.trainingsText }} | <strong>Anzahl:</strong> {{ item.attendees
                        }}
                    </p>
                    <p v-if="item.comment !== ''" class="m-0">
                        <strong>Kommentar:</strong> {{ item.comment }}
                    </p>
                </div>
                <button class="btn btn-outline-danger btn-sm" @click="emitDeleteTraining(item.unique_id)"><i
                    class="far fa-trash-alt"></i>
                </button>
            </li>
        </ul>

        <div v-else
             class="list-group list-group-flush">
            <slot name="empty-list-text"></slot>
        </div>
    </div>
</template>

<script>
export default {
    name: 'SignupList',

    props: {
        filterTrainingsList: null,
    },

    methods: {
        emitDeleteTraining: function(index) {
            this.$emit('deleteTraining', index);
        },
    },
};
</script>

<style scoped>
.margin-top {
    margin-top: 30px !important;
}
</style>
